import apiClient from "./client";
import type {
  CustomersListResponse,
  GetCustomersParams,
} from "../types/site";

export const getCustomers = async (
  params: GetCustomersParams
): Promise<CustomersListResponse> => {
  const { data } = await apiClient.get<CustomersListResponse>("/customers", {
    params: {
      disaster_id: params.disaster_id,
      pref_code: params.pref_code,
      m_branch_id: params.m_branch_id,
      order: params.order,
      sort: params.sort,
      page: params.page,
    },
  });
  return data;
};
